export default __webpack_public_path__ + "static/media/chat-communication.e7bfbc79.svg";